/* ============ NOT EQUALL — theme.js ============ */
(function () {
  'use strict';
  var NE = window.NE || {};

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = NE.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    // money format
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var value = whole + ',' + parts[1];
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, value)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value);
  }

  /* ---------- countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var deadline = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(deadline)) return;
      var dd = el.querySelector('[data-cd-dd]'), hh = el.querySelector('[data-cd-hh]'),
          mm = el.querySelector('[data-cd-mm]'), ss = el.querySelector('[data-cd-ss]'),
          inline = el.querySelector('[data-cd-inline]');
      function p(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, deadline - Date.now());
        var d = Math.floor(diff / 86400000); diff -= d * 86400000;
        var h = Math.floor(diff / 3600000); diff -= h * 3600000;
        var m = Math.floor(diff / 60000); diff -= m * 60000;
        var s = Math.floor(diff / 1000);
        if (dd) dd.textContent = p(d);
        if (hh) hh.textContent = p(h);
        if (mm) mm.textContent = p(m);
        if (ss) ss.textContent = p(s);
        if (inline) inline.textContent = d + 'D ' + p(h) + ':' + p(m) + ':' + p(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = null;
  function getDrawer() { return drawer || (drawer = document.getElementById('CartDrawer')); }

  function openDrawer() { var d = getDrawer(); if (d) { d.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { var d = getDrawer(); if (d) { d.classList.remove('open'); document.body.style.overflow = ''; } }

  function renderDrawer(cart) {
    var d = getDrawer(); if (!d) return;
    var itemsEl = d.querySelector('[data-drawer-items]');
    var subEl = d.querySelector('[data-drawer-subtotal]');
    var footEl = d.querySelector('[data-drawer-foot]');
    // header count
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = cart.item_count;
      c.setAttribute('data-count', cart.item_count);
    });

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="drawer__empty">Your cart is empty.<br>No restock, catch the next drop.</div>';
      if (footEl) footEl.style.display = 'none';
    } else {
      if (footEl) footEl.style.display = '';
      itemsEl.innerHTML = cart.items.map(function (it) {
        var opt = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
        var img = it.image ? '<div class="ditem__img"><img src="' + it.image.replace(/(\.[^.\/]+)(\?.*)?$/, '_120x$1$2') + '" alt=""></div>' : '<div class="ditem__img"></div>';
        return '<div class="ditem" data-key="' + it.key + '">' +
          img +
          '<div><div class="ditem__t">' + it.product_title + '</div>' +
          '<div class="ditem__o">' + opt + '</div>' +
          '<div class="qty"><button data-dminus>−</button><span>' + it.quantity + '</span><button data-dplus>+</button></div></div>' +
          '<div><div class="ditem__p">' + formatMoney(it.final_line_price) + '</div>' +
          '<button class="citem__remove" data-dremove>REMOVE</button></div>' +
          '</div>';
      }).join('');
    }
    if (subEl) subEl.textContent = formatMoney(cart.total_price);

    // free shipping bar
    var bar = d.querySelector('[data-ship-fill]');
    var lbl = d.querySelector('[data-ship-label]');
    var threshold = parseInt(NE.freeShipThreshold || 0, 10);
    if (bar && threshold > 0) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      bar.style.width = pct + '%';
      var remain = threshold - cart.total_price;
      if (lbl) lbl.innerHTML = remain > 0
        ? 'You’re <b>' + formatMoney(remain) + '</b> away from free shipping'
        : '<b>Free shipping unlocked ✓</b>';
    }
  }

  function fetchCart() {
    return fetch(NE.routes.cart_json, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); return cart; });
  }

  function addToCart(id, qty) {
    return addItems([{ id: id, quantity: qty || 1 }]);
  }

  function addItems(items) {
    return fetch(NE.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { openDrawer(); return cart; });
  }

  function changeLine(key, qty) {
    return fetch(NE.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); refreshCartPage(cart); return cart; });
  }

  function setDiscount(codes) {
    return fetch(NE.routes.cart_update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes })
    }).then(function (r) { return r.json(); });
  }

  /* refresh the full cart PAGE if present */
  function refreshCartPage(cart) {
    var page = document.querySelector('[data-cart-page]');
    if (page) { window.location.reload(); }
  }

  /* ---------- delegated events ---------- */
  function bindEvents() {
    document.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-cart-toggle]')) { e.preventDefault(); fetchCart().then(openDrawer); return; }
      if (t.closest('[data-drawer-close]') || t.classList.contains('drawer__overlay')) { closeDrawer(); return; }

      // PDP thumbnail swap
      var thumb = t.closest('[data-thumb]');
      if (thumb) {
        var main = document.getElementById('PdpMain');
        if (main) main.src = thumb.getAttribute('data-thumb');
        var sibs = thumb.parentNode ? thumb.parentNode.querySelectorAll('[data-thumb]') : [];
        for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
        thumb.classList.add('is-active');
        return;
      }

      // add to cart buttons (product cards / upsell quick add)
      var add = t.closest('[data-add-id]');
      if (add) {
        e.preventDefault();
        var vid = add.getAttribute('data-add-id');
        if (vid) { add.disabled = true; add.style.opacity = '.5'; addToCart(vid, 1).then(function () { add.disabled = false; add.style.opacity = ''; }); }
        return;
      }

      // add a bundle (multiple variant ids, comma separated)
      var bundle = t.closest('[data-add-bundle]');
      if (bundle) {
        e.preventDefault();
        var ids = bundle.getAttribute('data-add-bundle').split(',').filter(Boolean);
        if (ids.length) {
          bundle.disabled = true; bundle.style.opacity = '.5';
          addItems(ids.map(function (i) { return { id: i.trim(), quantity: 1 }; }))
            .then(function () { bundle.disabled = false; bundle.style.opacity = ''; });
        }
        return;
      }

      // drawer qty
      var line = t.closest('.ditem');
      if (line) {
        var key = line.getAttribute('data-key');
        var qtyNow = parseInt(line.querySelector('.qty span').textContent, 10);
        if (t.hasAttribute('data-dplus')) { changeLine(key, qtyNow + 1); return; }
        if (t.hasAttribute('data-dminus')) { changeLine(key, Math.max(0, qtyNow - 1)); return; }
        if (t.hasAttribute('data-dremove')) { changeLine(key, 0); return; }
      }

      // cart page: drop applied discount code
      if (t.closest('[data-promo-remove]')) { setDiscount('').then(function () { window.location.reload(); }); return; }

      // cart page qty / remove
      var crow = t.closest('[data-cart-line]');
      if (crow) {
        var ckey = crow.getAttribute('data-cart-line');
        var cqty = parseInt(crow.getAttribute('data-qty'), 10);
        if (t.hasAttribute('data-cplus')) { changeLine(ckey, cqty + 1); return; }
        if (t.hasAttribute('data-cminus')) { changeLine(ckey, Math.max(0, cqty - 1)); return; }
        if (t.hasAttribute('data-cremove')) { changeLine(ckey, 0); return; }
      }

      // quantity stepper
      var qbtn = t.closest('[data-qplus]') || t.closest('[data-qminus]');
      if (qbtn) {
        var qf = qbtn.closest('[data-product-form]');
        var qi = qf && qf.querySelector('[name="quantity"]');
        if (qi) {
          var qn = parseInt(qi.value, 10) || 1;
          qn += t.closest('[data-qplus]') ? 1 : -1;
          if (qn < 1) qn = 1;
          qi.value = qn;
        }
        return;
      }

      // size selector
      var size = t.closest('[data-size]');
      if (size && !size.classList.contains('is-out')) {
        var form = size.closest('form');
        form.querySelectorAll('[data-size]').forEach(function (s) { s.classList.remove('is-selected'); });
        size.classList.add('is-selected');
        var hidden = form.querySelector('[name="id"]');
        var vid = size.getAttribute('data-variant');
        if (hidden && vid) hidden.value = vid;
        var atc = form.querySelector('[data-atc]');
        if (atc) { atc.disabled = false; atc.textContent = atc.getAttribute('data-label-ready') || 'Add to cart'; }
        return;
      }
    });

    // product form submit
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      if (!id) return;
      var qEl = form.querySelector('[name="quantity"]');
      var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
      addToCart(id, qty);
    });

    // cart page discount code
    document.addEventListener('submit', function (e) {
      var promo = e.target.closest('[data-promo]');
      if (!promo) return;
      e.preventDefault();
      var input = promo.querySelector('[name="discount"]');
      var code = input.value.trim().toUpperCase();
      if (!code) return;
      var btn = promo.querySelector('button');
      var prev = Array.prototype.map.call(document.querySelectorAll('.promo__tag span'), function (el) { return el.textContent; }).join(',');
      btn.disabled = true;
      setDiscount(code).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
        if (hit && hit.applicable) { window.location.reload(); return; }
        btn.disabled = false;
        var msg = document.querySelector('[data-promo-msg]');
        if (msg) { msg.textContent = 'This code isn’t valid for your cart.'; msg.hidden = false; }
        // put back whatever was applied before, so a typo doesn't wipe a working code
        setDiscount(prev);
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    bindEvents();
    fetchCart();
  });
})();
